import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import ItemList from "../ItemList";

function AdminFees(){
    const[searchUi,setSearchUi]=useState(true)
    const[searchContent,setSearchContent]=useState('')

    return(

        <DataContext.Provider value={{searchUi,setSearchUi,searchContent,setSearchContent}}>
        <Navbar 
         navId={3}
        childrenPage={<ItemList/>}/>
        </DataContext.Provider>
    )
}

export default AdminFees;